/**
 * AUTO-GENERATED by tools/curriculum/generate-html-css-static-aliases.ts.
 * Source: content/curriculum-restructures/html-css-v1/plan.json
 * Static alias contract SHA-256: 65c0c1e8bcd0b4dc3180d406e56f338a068018403e7dd936b5e262fdf1055ce1
 *
 * Old lesson keys remain the only enumerable static-asset identities. New keys
 * are lookup aliases to the same objects and CONTENT records, never copies.
 * Do not edit this file by hand.
 */

export interface HtmlCssCourseSplitLessonAlias {
  lessonId: string;
  oldKey: string;
  newKey: string;
  oldCourseSlug: "css-layout";
  newCourseSlug: "responsive-web";
  lessonSlug: string;
}

export const HTML_CSS_STATIC_ALIAS_COUNT = 10 as const;
export const HTML_CSS_STATIC_ALIAS_FINGERPRINT =
  "65c0c1e8bcd0b4dc3180d406e56f338a068018403e7dd936b5e262fdf1055ce1" as const;

export const HTML_CSS_LESSON_ALIASES = Object.freeze([
  {
    lessonId: "84bb298b-6df8-4a07-889b-4ecdbf84593e",
    oldKey: "css-layout/cl-ch3-review",
    newKey: "responsive-web/cl-ch3-review",
    oldCourseSlug: "css-layout",
    newCourseSlug: "responsive-web",
    lessonSlug: "cl-ch3-review",
  },
  {
    lessonId: "87832edf-03ab-484e-af39-e9c4ff1609ea",
    oldKey: "css-layout/cl-final-audit",
    newKey: "responsive-web/cl-final-audit",
    oldCourseSlug: "css-layout",
    newCourseSlug: "responsive-web",
    lessonSlug: "cl-final-audit",
  },
  {
    lessonId: "84a8775b-6e28-4221-8215-cfd06a514112",
    oldKey: "css-layout/cl-final-extra",
    newKey: "responsive-web/cl-final-extra",
    oldCourseSlug: "css-layout",
    newCourseSlug: "responsive-web",
    lessonSlug: "cl-final-extra",
  },
  {
    lessonId: "231fab17-4136-4f83-b338-0fa42d9ff1e6",
    oldKey: "css-layout/cl-final-polish",
    newKey: "responsive-web/cl-final-polish",
    oldCourseSlug: "css-layout",
    newCourseSlug: "responsive-web",
    lessonSlug: "cl-final-polish",
  },
  {
    lessonId: "afcce8a3-e336-4a1b-9d48-3d10ceeb60be",
    oldKey: "css-layout/cl-final-publish",
    newKey: "responsive-web/cl-final-publish",
    oldCourseSlug: "css-layout",
    newCourseSlug: "responsive-web",
    lessonSlug: "cl-final-publish",
  },
  {
    lessonId: "998cc00c-385a-4c5f-afee-bf0874a5a518",
    oldKey: "css-layout/cl-media-queries",
    newKey: "responsive-web/cl-media-queries",
    oldCourseSlug: "css-layout",
    newCourseSlug: "responsive-web",
    lessonSlug: "cl-media-queries",
  },
  {
    lessonId: "d03e8363-1ccd-4d05-a3e2-9d3ccfe3acab",
    oldKey: "css-layout/cl-mobile-first",
    newKey: "responsive-web/cl-mobile-first",
    oldCourseSlug: "css-layout",
    newCourseSlug: "responsive-web",
    lessonSlug: "cl-mobile-first",
  },
  {
    lessonId: "010eecd0-25d9-4dee-aeb4-d498e3401bea",
    oldKey: "css-layout/cl-relative-units",
    newKey: "responsive-web/cl-relative-units",
    oldCourseSlug: "css-layout",
    newCourseSlug: "responsive-web",
    lessonSlug: "cl-relative-units",
  },
  {
    lessonId: "84c252f9-9133-492a-af34-2861cbf91cfa",
    oldKey: "css-layout/cl-responsive-intro",
    newKey: "responsive-web/cl-responsive-intro",
    oldCourseSlug: "css-layout",
    newCourseSlug: "responsive-web",
    lessonSlug: "cl-responsive-intro",
  },
  {
    lessonId: "653b8e7e-f765-42e2-b96a-ff2ed22d3107",
    oldKey: "css-layout/cl-viewport",
    newKey: "responsive-web/cl-viewport",
    oldCourseSlug: "css-layout",
    newCourseSlug: "responsive-web",
    lessonSlug: "cl-viewport",
  },
]) satisfies readonly HtmlCssCourseSplitLessonAlias[];

export const HTML_CSS_OLD_TO_NEW_LESSON_KEY: Readonly<Record<string, string>> =
  Object.freeze(
    Object.fromEntries(
      HTML_CSS_LESSON_ALIASES.map(({ oldKey, newKey }) => [oldKey, newKey]),
    ),
  );

export const HTML_CSS_NEW_TO_OLD_LESSON_KEY: Readonly<Record<string, string>> =
  Object.freeze(
    Object.fromEntries(
      HTML_CSS_LESSON_ALIASES.map(({ oldKey, newKey }) => [newKey, oldKey]),
    ),
  );

export const HTML_CSS_TARGET_COURSE_TITLES: Readonly<Record<string, string>> =
  Object.freeze({
  "css-basics": "CSS入門：色・文字・余白で装飾する",
  "css-layout": "CSSレイアウト：Flexbox・Gridで配置する",
  "html-basics": "HTML入門：Webページの骨組みをつくる",
  "responsive-web": "レスポンシブWeb制作：スマホ対応して公開する",
  });

export const HTML_CSS_TARGET_COURSE_SHORT_TITLES: Readonly<
  Record<string, string>
> = Object.freeze({
  "css-basics": "CSS入門",
  "css-layout": "CSSレイアウト",
  "html-basics": "HTML入門",
  "responsive-web": "レスポンシブWeb制作",
});

/** Stable static identity shared before and after the ownership transaction. */
export function canonicalHtmlCssLessonKey(key: string): string {
  return HTML_CSS_NEW_TO_OLD_LESSON_KEY[key] ?? key;
}

/** Both public keys for a moved lesson; one key for an unaffected lesson. */
export function htmlCssLessonKeyAliases(key: string): readonly string[] {
  const canonical = canonicalHtmlCssLessonKey(key);
  const next = HTML_CSS_OLD_TO_NEW_LESSON_KEY[canonical];
  return next ? [canonical, next] : [canonical];
}
